import jwt from "jsonwebtoken"

import executeQuery from "../lib/db.js"
import log from "../log.js"
import { SECRET_KEY } from "../constants.js"
import { getUserApps, getUserAppPermissions } from "./users.js"

export const getUserByToken = async ({ token }: { token: string }) => {
	const { app_id, user_id } = jwt.verify(token, SECRET_KEY) as jwt.JwtPayload

	if (typeof app_id === "undefined") {
		log(`Could not extract a valid app_id from the token`)
		// return a 403 failure
		const error = new Error("Invalid token") as any
		error.status = 403
		throw error
	}
	if (typeof user_id === "undefined") {
		log(`Could not extract a valid user_id from the token`)
		// return a 403 failure
		const error = new Error("Invalid token") as any
		error.status = 403
		throw error
	}

	log(`Getting user_id ${user_id} for appID: ${app_id}`)

	const users = await executeQuery({
		query: `
			select
				display_name
			from
				users
			where
				user_id = ${user_id}
		`,
	})

	const results = {
		display_name: users[0].display_name,
		apps: await getUserApps({ user_id }),
		permissions: (await getUserAppPermissions({ user_id, app_id })).map(
			({ permission }: { permission: string }) => permission,
		),
	}

	// log(`Results for user_id ${user_id} and appID ${app_id}:`)
	// log(JSON.stringify(results, null, 2))

	return results
}
